// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { QuoteLineModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export type RfqQuoteDetailsProposedState = {
    productLinesQtyToUpdate: QuoteLineModel[];
};

const initialState: RfqQuoteDetailsProposedState = {
    productLinesQtyToUpdate: [],
};

const XRfqQuoteDetailsProposedReducer = createTypedReducerWithImmer(initialState, {
    "Pages/xRfqQuoteDetailsProposed/UpdateProductsQty": (
        draft: Draft<RfqQuoteDetailsProposedState>,
        action: { lineModel: QuoteLineModel & { originalQty?: number } },
    ) => {
        const existingObjectIndex = draft.productLinesQtyToUpdate.findIndex(
            item =>
                item.id === action.lineModel.id &&
                item.productId === action.lineModel.productId &&
                item.properties.originalGroupName === action.lineModel.properties.originalGroupName,
        );

        if (existingObjectIndex !== -1) {
            if (action.lineModel.qtyOrdered === action.lineModel.originalQty) {
                draft.productLinesQtyToUpdate = draft.productLinesQtyToUpdate.filter(
                    (element, index) => index !== existingObjectIndex,
                );
            } else {
                delete action.lineModel.originalQty;
                draft.productLinesQtyToUpdate[existingObjectIndex] = {
                    ...action.lineModel,
                };
            }
        } else {
            delete action.lineModel.originalQty;
            draft.productLinesQtyToUpdate.push(action.lineModel);
        }
    },
    "Pages/xRfqQuoteDetailsProposed/ClearProductsQty": (draft: Draft<RfqQuoteDetailsProposedState>) => {
        draft.productLinesQtyToUpdate = [];
    },
});

(reducers as any).xRfqQuoteDetailsProposed = XRfqQuoteDetailsProposedReducer;

export type xRfqQuoteDetailsProposedState = {
    xRfqQuoteDetailsProposed: RfqQuoteDetailsProposedState;
};

export type xRfqQuoteDetailsProposedReducer = {
    rfqRequestQuote: typeof XRfqQuoteDetailsProposedReducer;
};

export type xRfqQuoteDetailsProposedActions =
    | Parameters<xRfqQuoteDetailsProposedReducer[keyof xRfqQuoteDetailsProposedReducer]>[1]
    | AnyAction;
